import { createContext, useContext } from 'react'
import { type SendFromMultiStore } from '../store/SendFromMultiStore'

export const SendFromMultiContext = createContext<SendFromMultiStore | null>(null)

export const useSendFromMultiContext = () => {
  const context = useContext(SendFromMultiContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SendFromMultiContext')

  return context
}
